import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { gateway } from '../../utils/api';
import { getLoginTenantURL } from '../../utils/functions';
import { LitText } from '../shared/LitText';
import { LitButton } from '../shared/LitButton';

const ResendContainer = styled.div`
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  
  @media (max-width: 768px) {
    margin-top: 1.5rem;
    padding-top: 1.5rem;
  }
`;

const EmailInputContainer = styled.div`
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
  
  .field-float-label-pattern {
    width: 100%;
    
    input {
      width: 100%;
      padding: 12px;
      border: 2px solid #27aae1;
      border-radius: 8px;
      font-size: 16px;
      transition: all 0.3s ease;
      
      &:focus {
        outline: none;
        border-color: #02c4fd;
        box-shadow: 0 0 0 3px rgba(39, 170, 225, 0.1);
      }
    }
  }
`;

class RetornoLogin extends PureComponent {
  state = {
    loading: false,
    showInput: false,
    email: ''
  };

  resendEmail = async () => {
    try {
      const { email } = this.state;
      const { notif } = this.props;
      const emailData = localStorage.getItem('ra') || email;
      if (!emailData) {
        this.setState({ showInput: true });
        return;
      }

      this.setState({
        loading: true
      });

      const urlParams = new URLSearchParams(window.location.search);
      const origin = urlParams.get('o');
      const tenant = getLoginTenantURL(window.location.search);

      let url = `/notification/notification/sendConfirmation/${emailData}`;

      if (origin) {
        url += `?o=${origin}`;
      }
      if (tenant) {
        if (origin) {
          url += `&tenant=${tenant}`;
        } else {
          url += `?tenant=${tenant}`;
        }
      }

      const response = await gateway.post(url);

      this.setState({
        loading: false,
        showInput: false,
        email: ''
      });
      notif(response.message);
    } catch (error) {
      this.setState({
        loading: false
      });
      const { notif } = this.props;
      notif(error.response.data.message);
    }
  };

  render() {
    const { loading, showInput, email } = this.state;
    return (
      <ResendContainer>
        <LitText className="text-center" style={{ marginBottom: 0 }}>
          Não recebeu o email de confirmação?
        </LitText>
        {showInput && (
          <EmailInputContainer>
            <div className="field-float-label-pattern">
              <div>
                <input
                  type="email"
                  placeholder="Digite seu email"
                  className="form-control"
                  id="inputEmail"
                  value={email}
                  onChange={evt => this.setState({ email: evt.target.value })}
                  required
                  inputMode="email"
                  autoComplete="email"
                />
                <label htmlFor="inputEmail">Email</label>
              </div>
            </div>
          </EmailInputContainer>
        )}
        <LitButton
          type="button"
          onClick={this.resendEmail}
          disabled={loading || (showInput && !email)}
          style={{
            textTransform: 'uppercase',
            minWidth: '200px'
          }}
          className={loading ? 'btn-loading' : ''}
        >
          Reenviar email
        </LitButton>
      </ResendContainer>
    );
  }
}

export default RetornoLogin;
